import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { TaskbookTriageComponent } from "./taskbook-triage.component";
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CommonModule } from "@angular/common";
import { MoodTaskComponent } from "./task/mood-task/mood-task.component";
import { KudosTaskComponent } from "./task/kudos-task/kudos-task.component";
import { TopicTaskComponent } from "./task/topic-task/topic-task.component";
import { BadMoodStreakTaskComponent } from "./task/bad-mood-streak-task/bad-mood-streak-task.component";
import { ReactionsComponent, ThreadInputAreaComponent } from "@teammood/timeline";
import { ThreadsComponent } from "../timeline/threads/threads.component";
import { GifPreviewComponent } from "../shared/ui/gifpreview/gifpreview";
import { LinkPreviewComponent } from "../shared/ui/linkpreview/linkpreview";
import { TmPipesModule } from "../shared/util/pipes";
import { LinkyModule } from "@teammood/shared/util/linky";
import { TaskThreadsComponent } from "./task/task-threads/task-threads.component";
import { KudosRecipientsDisplayComponent } from "../timeline/timeline-item/kudos/kudos-recipients-display.component";
import {
    AgreeDisagreeQuestionResultBarChartComponent
} from "../timeline/timeline-item/poll-result/agree-disagree-poll-result/agree-disagree-poll-result-bar-chart/agree-disagree-question-result-bar-chart.component";
import { TaskComponent } from "./task/task.component";
import { MatButtonModule } from "@angular/material/button";
import { MatMenuModule } from "@angular/material/menu";
import { TaskSucessDialogComponent } from "./task-action-dialogs/task-success-dialog/task-success-dialog.component";
import { MultiTeamSelectorComponent } from "@teammood/shared/ui/multi-team-selector";
import { TaskActionsComponent } from "./task-actions/task-actions.component";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatExpansionModule } from "@angular/material/expansion";
import { SavedFilterComponent } from "../filter/saved-filter/saved-filter.component";
import { AnnouncementComponent } from "../shared/ui/announcement/announcement.component";
import { PollResultTaskComponent } from "./task/poll-result-task/poll-result-task.component";
import {
    AgreeDisagreePollResultTaskComponent
} from "./task/agree-disagree-poll-result-task/agree-disagree-poll-result-task.component";
import {
    FiveStarsPollResultTaskComponent
} from "./task/five-stars-poll-result-task/five-stars-poll-result-task.component";
import { ScalePollResultTaskComponent } from "./task/scale-poll-result-task/scale-poll-result-task.component";
import {
    ClosedQuestionResultBarChartComponent
} from "../timeline/timeline-item/poll-result/closed-poll-result/closed-question-result-bar-chart/closed-result-bar-chart.component";
import {
    ScalePollResultPyramidChartComponent
} from "../timeline/timeline-item/poll-result/scale-poll-result/scale-question-result-pyramid-chart/scale-question-result-pyramid-chart.component";
import {
    PollResultCommentsComponent
} from "../timeline/timeline-item/poll-result/poll-result-comments/poll-result-comments.component";
import { RouterLink } from "@angular/router";
import { RecurringClosedPollResultTrendsChartComponent } from "../timeline/timeline-item/poll-result/recurring/recurring-closed-poll-result-trends-chart/recurring-closed-poll-result-trends-chart.component";
import { RecurringPollResultTrendsLineChartComponent } from "../timeline/timeline-item/poll-result/recurring/recurring-poll-result-trends-line-chart/recurring-poll-result-trends-line-chart.component";
import { MatTabsModule } from "@angular/material/tabs";
import { PollTaskRecurrenceDialogComponent } from "./task-action-dialogs/poll-task-recurrence-dialog/poll-task-recurrence-dialog.component";
import { A11yModule } from "@angular/cdk/a11y";
import { RecurringPollResultTrendsComponent } from "../timeline/timeline-item/poll-result/recurring/recurring-poll-result-trends.component";
import { TaskbookTriageActionsComponent } from "./taskbook-triage-actions/taskbook-triage-actions.component";

@NgModule({
    declarations: [
        TaskbookTriageComponent,
        TaskComponent,
        MoodTaskComponent,
        KudosTaskComponent,
        TopicTaskComponent,
        BadMoodStreakTaskComponent,
        PollResultTaskComponent,
        AgreeDisagreePollResultTaskComponent,
        FiveStarsPollResultTaskComponent,
        ScalePollResultTaskComponent,
    ],
    imports: [
        TranslateModule,
        MatProgressBarModule,
        CommonModule,
        LinkyModule,
        TmPipesModule,
        ReactionsComponent,
        ThreadsComponent,
        GifPreviewComponent,
        LinkPreviewComponent,
        TaskThreadsComponent,
        KudosRecipientsDisplayComponent,
        ClosedQuestionResultBarChartComponent,
        AgreeDisagreeQuestionResultBarChartComponent,
        ScalePollResultPyramidChartComponent,
        MatButtonModule,
        MatMenuModule,
        TaskSucessDialogComponent,
        MultiTeamSelectorComponent,
        TaskActionsComponent,
        MatTooltipModule,
        ThreadInputAreaComponent,
        MatExpansionModule,
        SavedFilterComponent,
        AnnouncementComponent,
        PollResultCommentsComponent,
        RouterLink,
        TaskbookTriageActionsComponent,
        PollTaskRecurrenceDialogComponent,
        TmPipesModule,
        MatTabsModule,
        RecurringPollResultTrendsComponent,
        RecurringClosedPollResultTrendsChartComponent,
        RecurringPollResultTrendsLineChartComponent,
        A11yModule
    ],
    exports: [
        TaskComponent,
        KudosTaskComponent
    ]
})
  export class TmTaskbookModule{
  }